import { type PaletteDef, usePaletteTrigger } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { SidebarItemButton, Tooltip } from '@gitbook/spine-react';

/**
 * Sidebar action button used to trigger a palette from sidebar items.
 */
export function SidebarActionsButton(props: { palette: () => PaletteDef; disabled?: boolean }) {
    const { palette, disabled = false } = props;
    const { triggerProps } = usePaletteTrigger<HTMLDivElement>({
        palette: () => ({
            ...palette(),
            position: { preferredPlacement: 'right' },
        }),
    });
    return (
        <div className="group/sidebar-actions relative ml-auto flex w-0 shrink-0 items-center justify-end overflow-visible group-hover/sidebar-item:w-auto group-data-[focus-visible]/sidebar-item:w-auto focus-within:w-auto has-[[aria-expanded=true]]:w-auto">
            <Tooltip label="More actions">
                <SidebarItemButton
                    icon={Icon.MoreVertical}
                    {...triggerProps}
                    isDisabled={disabled}
                />
            </Tooltip>
        </div>
    );
}
